import React from 'react';
import { useTranslation } from 'react-i18next';

import TableCell from '@mui/material/TableCell';

import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import useLanguage from '../../../../components/_hook/useLanguage';
import Moment from '../../../../components/Moment';
import BaseImage from '../../../../components/_image/BaseImage';
import { IProductSchema } from '../../../../../graphql/type/product';
import CopyIconButton from '../../../../components/_iconButton/CopyIconButton';
import useRoutes from '../../../../components/_hook/useRoutes';
import SchemaCompanyName from '../../../../components/_schema/SchemaCompanyName';
import SchemaProductPrice from '../../../../components/_schema/SchemaProductPrice';
import LabelDropshippingRequestProductStatus from '../../_module/LabelDropshippingRequestProductStatus';
import DROPSHIPPING_REQUEST_PRODUCT from '../../../../components/constant/dropshippingRequestProduct';
import useKeepitalRoutes from '../../../../components/_hook/useKeepitalRoutes';

interface IProps {
  item: IProductSchema;
  setTableRefreshKey?: (tableRefreshKey: number) => void;
}

export default function DropshippedProductTableItem(props: IProps) {
  const { t } = useTranslation();
  const { item, setTableRefreshKey } = props;
  const { path } = useRoutes();
  const { getText } = useLanguage();
  const { path: keepitalPath } = useKeepitalRoutes();
  const images = item.media && item.media.images ? item.media.images : [];
  const image = images.find((tempImage) => tempImage.status);

  return (
    <>
      <TableCell align="left">
        <Tooltip title={item._id}>
          <Button
            color="primary"
            component="a"
            href={keepitalPath('company.showcase.product.index', {
              origin:
                item.companyData && item.companyData.origin
                  ? item.companyData.origin.toLowerCase()
                  : '',
              companySlug:
                item.companyData && item.companyData.slug
                  ? item.companyData.slug
                  : '',
              productSlug: item.slug,
            })}
            target="_blank"
          >
            {item._id.substr(0, 6)}
          </Button>
        </Tooltip>
        <CopyIconButton iconHtmlFontSize="0.8rem" copyText={item._id} />
      </TableCell>
      <TableCell align="left">{getText(item.name)}</TableCell>
      <TableCell align="center">
        {item.sourceDropshippedProductCompanyData && (
          <Button
            color="primary"
            component={Link}
            to={path('product.dropshipped.vendor.detail', {
              companyID: item.company,
              toCompanyID: item.sourceDropshippedProductCompanyID,
            })}
          >
            <SchemaCompanyName
              company={item.sourceDropshippedProductCompanyData}
              showVerification
            />
          </Button>
        )}
      </TableCell>
      <TableCell align="center">
        {image ? (
          <BaseImage
            src={image.filenameSmallUrl || image.filenameUrl}
            style={{
              maxWidth: '100px',
              height: '35px',
            }}
            lightboxImages={images.map((tempImage) => tempImage.filenameUrl)}
            title={getText(item.name)}
            alt={getText(item.name)}
          />
        ) : (
          <span>{`${t('no')} ${t('image')}`}</span>
        )}
      </TableCell>
      <TableCell align="center">
        <SchemaProductPrice product={item} redRfq />
      </TableCell>
      <TableCell align="center">
        <LabelDropshippingRequestProductStatus
          status={DROPSHIPPING_REQUEST_PRODUCT.STATUS.ALLOW}
        />
      </TableCell>
      <TableCell align="center">
        {item.created && item.created.time && (
          <Moment time={item.created.time} />
        )}
      </TableCell>
    </>
  );
}
